import apiClient from '../config/api';
import type { ApiResponse } from '@shared/types';

/**
 * 请求工具函数
 * 封装常用HTTP方法，统一返回 data 部分
 */

/** GET请求 */
export async function get<T = any>(url: string, params?: any): Promise<T> {
  const res = await apiClient.get<ApiResponse<T>>(url, { params });
  return (res as any).data ?? (res as any);
}

/** POST请求 */
export async function post<T = any>(url: string, data?: any): Promise<T> {
  const res = await apiClient.post<ApiResponse<T>>(url, data);
  return (res as any).data ?? (res as any);
}

/** PUT请求 */
export async function put<T = any>(url: string, data?: any): Promise<T> {
  const res = await apiClient.put<ApiResponse<T>>(url, data);
  return (res as any).data ?? (res as any);
}

/** DELETE请求 */
export async function del<T = any>(url: string, params?: any): Promise<T> {
  const res = await apiClient.delete<ApiResponse<T>>(url, { params });
  return (res as any).data ?? (res as any);
}

/** 文件上传 */
export async function upload<T = any>(url: string, file: File | Blob, fieldName: string = 'file'): Promise<T> {
  const formData = new FormData();
  formData.append(fieldName, file);
  const res = await apiClient.post<ApiResponse<T>>(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return (res as any).data ?? (res as any);
}

/** 文件下载（Blob响应） */
export async function downloadBlob(url: string, params?: any): Promise<Blob> {
  const res = await apiClient.get(url, {
    params,
    responseType: 'blob',
  });
  return (res as any).data as Blob;
}

/** 触发浏览器下载 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
